import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { trackPromise } from 'react-promise-tracker';
import { fetchWrapper } from '_utils/fetch-wrapper';
import { blobBrowserDownload } from '_utils/files/blobBrowserDownload';

// create slice

const name = 'filehub';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const filehubAction = { ...slice.actions, ...extraActions };
export const filehubReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        filehub: null
    }
}

function createExtraActions() {

    const baseUrl = `${process.env.REACT_APP_MARKETER_API_URL}/api/Master`;
    const baseUrl1 = `${process.env.REACT_APP_MARKETER_API_URL}/api/Marketer`;
    
   // const baseUrl = 'https:/localhost:7017/api/Marketer';

    return {
        get: get(),
        update: update(),
        download: download(),
        downloadFile: downloadFile(),
    };

    function downloadFile() {
      return createAsyncThunk(
        `${name}/downloadFile`,
        async ({ fileNames, fileType }, { rejectWithValue }) => {
          try {
            const params = new URLSearchParams();
            fileNames.forEach((fn) => params.append("fileNames", fn));
            params.append("fileType", fileType);

            const { blob, headers } = await fetchWrapper.getFile(
              `${baseUrl}/marketer/download-file?${params.toString()}`,
            );
            const fallbackFileName =
              fileNames.length === 1 ? fileNames[0] : null;
            
            blobBrowserDownload(blob, headers, fallbackFileName, false);
            return true;
          } catch (error) {
            return rejectWithValue(error);
          }
        },
      );
    }

    function get() {
        return createAsyncThunk(
            `${name}/filehub`,
            async (transformedData, { rejectWithValue }) => {
                try {
                    const url = new URL(`${baseUrl}/download`);
                    const response = await trackPromise(fetchWrapper.post(url.toString(),transformedData));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
  


    function update() { 
        return createAsyncThunk( 
            `${name}/update`,
            async (transformedData , { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl1}/upload`, {Data: transformedData}));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

     function download() { 
        return createAsyncThunk( 
            `${name}/download`,
            async (transformedData , { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/download`, {bulkDownloadFiles:transformedData}));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

}

function createReducers() {
    return {
        clear
    };

    function clear(state) {
        state.filehub = null;
    }
}

function createExtraReducers() {
    return (builder) => {
        get();

        function get() {
            var { pending, fulfilled, rejected } = extraActions.get;
            builder
                .addCase(pending, (state) => {
                    state.filehub = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    const data = action.payload;
                    state.filehub = data.Data;
                })
                .addCase(rejected, (state, action) => {
                    state.filehub = { error: action.error };
                });
        }
    };
}